import { SimpleFetchController as SimpleFetch } from "./fetch-controller/simple-fetch-controller";
import { ConnectedFetchNetworkController } from "./fetch-network-controller/connected-fetch-network-controller";
import { ConnectedFetchPlayerVersionStatsController } from "./fetch-player-version-stats-controller/connected-fetch-player-version-stats-controller";

SimpleFetch.Network = ConnectedFetchNetworkController;
SimpleFetch.PlayerVersionsStats = ConnectedFetchPlayerVersionStatsController;

export { SimpleFetch };
